// dependencies
import React from "react";
import { StyleSheet } from "react-native";

// components
import BaseComponent from "../BaseComponent";
import Text from "../Text";
import { List, ListItem } from "../List";

// libraries
import { emToPx } from "../../libraries";

type PropsType = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  icon: React.ReactNode;
};

const styles = StyleSheet.create({
  jumbotron: {
    borderStyle: "solid",
    borderColor: "#000000",
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 1,
    borderLeftWidth: 0,
    paddingBottom: emToPx(1),
  },
  icon: {
    fontSize: emToPx(3),
  },
});

const Jumbotron: React.FunctionComponent<PropsType> = (props) => {
  const { icon, title, subtitle } = props;

  return (
    <BaseComponent containerStyle={styles.jumbotron}>
      <List gutter={1} inline={true}>
        <ListItem style={{ justifyContent: "center" }}>
          <Text style={styles.icon}>{icon}</Text>
        </ListItem>

        <ListItem style={{ justifyContent: "center", flex: 1 }}>
          <List gutter={0.5}>
            <ListItem>{title}</ListItem>
            {undefined !== subtitle && <ListItem>{subtitle}</ListItem>}
          </List>
        </ListItem>
      </List>
    </BaseComponent>
  );
};

export default Jumbotron;
